import Visa from './visa.svg'
import Amex from './american_express.svg'
import Cartes from './cartes_bancaires.svg'
import Jcb from './jcb.svg'
import Eftpos from './eftpos.svg'
import Diners from './diners_club.svg'
import Discover from './discover.svg'
import MasterCard from './mastercard.svg'
import UnionPay from './unionpay.svg'

export { Visa, Amex, Cartes, Jcb, Eftpos, Diners, Discover, MasterCard, UnionPay }
